import { COOKIE_KEYS } from 'constants/common'
import Cookies from 'js-cookie'
import { decodeBase64ToObject } from 'utils/common/dataEncoding'

export const addSuperAdminHeaders = (options: RequestInit): RequestInit => {
  const superAdminProviderData = getProviderDataFromSuperAdminData(
    Cookies.get(COOKIE_KEYS.SUPERADMIN_DATA) ?? ''
  )
  const newOptions = { ...options }

  if (
    superAdminProviderData?.providerId &&
    superAdminProviderData?.ehrProfileCode
  ) {
    newOptions.headers['provider_id'] = superAdminProviderData.providerId
    newOptions.headers['ehr_profile_code'] =
      superAdminProviderData.ehrProfileCode
  }

  return newOptions
}

export const getProviderDataFromSuperAdminData = (
  cookieData: string
): FormattedSuperAdminProviderData => {
  return decodeBase64ToObject<FormattedSuperAdminProviderData>(cookieData)
}
